import { qsa, qs, contains, add, remove } from '@fluorescent/dom';
import { section } from '@/glow';

const selectors = {
  addressContainer: '[data-address]',
  addressToggle: '[data-address-toggle]',
  addressCountry: '[data-address-country]',
  addressProvince: '[data-address-province]',
  addressProvinceWrapper: '[data-address-province-wrapper]',
  addressForm: '[data-address-form]',
  addressDeleteForm: '[data-address-delete-form]',
};
const hideClass = 'hide';

section('addresses', {
  onLoad() {
    const addresses = qsa(selectors.addressContainer, this.container);
    const countryOptions = qsa('[data-country-option]', this.container) || [];

    countryOptions.forEach(el => {
      const { formId } = el.dataset;

      const countrySelector = 'AddressCountry_' + formId;
      const provinceSelector = 'AddressProvince_' + formId;
      const containerSelector = 'AddressProvinceContainer_' + formId;

      new window.Shopify.CountryProvinceSelector(
        countrySelector,
        provinceSelector,
        {
          hideElement: containerSelector,
        }
      );
    });

    addresses.forEach(addressContainer => {
      this.initializeAddressForm(addressContainer);
    });
  },

  initializeAddressForm(container) {
    const addressForm = qs(selectors.addressForm, container);
    const deleteForm = qs(selectors.addressDeleteForm, container);

    qsa(selectors.addressToggle, container).forEach(button => {
      button.addEventListener('click', () => {
        if (contains(addressForm, hideClass)) {
          remove(addressForm, hideClass);
          addressForm.setAttribute('aria-hidden', 'false');
        } else {
          add(addressForm, hideClass);
          addressForm.setAttribute('aria-hidden', 'true');
        }
      });
    });

    if (deleteForm) {
      deleteForm.addEventListener('submit', event => {
        const confirmMessage = deleteForm.getAttribute('data-confirm-message');

        if (
          !window.confirm(
            confirmMessage || 'Are you sure you wish to delete this address?'
          )
        ) {
          event.preventDefault();
        }
      });
    }
  },
});
